module.exports = __webpack_public_path__ + "img/you_can_do_better.aea27013.svg";